import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../utils/liffHelper';
import { Redirect } from 'react-router-dom'


// const styles = theme => {
//   return ({
//       myTab: {
//         fontFamily: 'Courier New',
//     });
// }

const useStyles = makeStyles(theme => ({
  // return ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  avatar: {
    margin: 10,
  },
}));



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {
        pictureUrl: "https://linebotkeep-file.s3-ap-southeast-1.amazonaws.com/QR/4-512.png",
        displayName: 'Displayname',
        type: this.props.location.state.type,
        viewType: this.props.location.state.viewType,
        userId: this.props.location.state.userId,
        utouId: this.props.location.state.utouId,
        roomId: this.props.location.state.roomId,
        groupId: this.props.location.state.groupId,
        displayName: this.props.location.state.displayName,
        pictureUrl: this.props.location.state.pictureUrl
      },
      mongo: {
        Ck_NameL: false,
        Ck_NameF: false
      },
      redi: {
        redirect: false,
        redirectnogroup: false
      },
      pass: this.props.location.state.password
    };
  }
  async componentDidMount() {
    // const profile = await liffHelper.initcontext()
    // const profile2 = await liffHelper.getProfile()
    // // alert(profile2.userId)
    // this.setState({
    //   profile: {
    //     type: profile.type,
    //     viewType: profile.viewType,
    //     userId: profile.userId,
    //     utouId: profile.utouId,
    //     roomId: profile.roomId,
    //     groupId: profile.groupId,
    //     displayName: profile2.displayName,
    //     pictureUrl: profile2.pictureUrl
    //   },
    //   // redi:{redirect: true}
    // });
    // alert(this.state.profile.groupId)
    var collecq = "Ck_Data";
    if (this.state.pass == "Motor" || this.state.pass == "Rplc") {
      // alert(this.state.pass)
      collecq = "Ck_Data_RPLC";
    }
    if (this.state.pass == "Aicp") {
      // alert(this.state.pass)
      collecq = "Ck_Data_AIC";
    }
    // else{
    //   alert('SSS')
    // }
    // alert(this.state.pass)
    // alert(collecq)
    const nna = await liffHelper.checkmongo(this.state.profile.userId, collecq)
    // alert(nna)
    if (nna != undefined) {
      // alert(nna.Ck_NameF)
      this.setState({
        mongo: {
          ...this.state.mongo,
          Ck_NameF: nna.Ck_NameF,
          Ck_NameL: nna.Ck_NameL,
          Ck_Brance: nna.Ck_Brance,
          idfb: nna.idfb
        }
      })
    } else {
      // if (this.state.profile.groupId != "Ce4da4f72ef6b62ae7a591a15a7d8af50") {
      //   this.setState({
      //     redi: {
      //       ...this.state.redi,
      //       redirectnogroup: true,
      //     }
      //   })
      // } else {
        if (nna == undefined) {
          this.setState({
            redi: {
              ...this.state.redi,
              redirect: true,
            }
          })
        }
      // }
    }
  }
  renderRedirect = () => {
    // if (this.state.profile.groupId == "Ce4da4f72ef6b62ae7a591a15a7d8af50") {
      // alert(this.state.profile.groupId)
      if (this.state.redi.redirect != false) {
        // alert(this.state.redi.redirect)
        return <Redirect
          to={{
            pathname: '/login',
            state: { id: this.state.profile.displayName,
                     password: this.state.pass }
          }}
        />
      } if (this.state.mongo.Ck_NameF != false) {
        if (this.state.pass == "Motor" || this.state.pass == "Rplc") {
          return <Redirect
          to={{
            pathname: '/CreatGroup_RPLC',
            state: {
              Ck_NameF: this.state.mongo.Ck_NameF,
              Ck_NameL: this.state.mongo.Ck_NameL,
              Ck_Brance: this.state.mongo.Ck_Brance,
              idfb: this.state.mongo.idfb,
              groupId: this.state.profile.groupId,
              password: this.state.pass
            }
          }}
        />
        } else if(this.state.pass == "Rafco") {
          return <Redirect
          to={{
            pathname: '/creatGroup',
            state: {
              Ck_NameF: this.state.mongo.Ck_NameF,
              Ck_NameL: this.state.mongo.Ck_NameL,
              Ck_Brance: this.state.mongo.Ck_Brance,
              idfb: this.state.mongo.idfb,
              groupId: this.state.profile.groupId,
              password: this.state.pass
            }
          }}
        />
        } else if(this.state.pass == "Aicp") {
          return <Redirect
          to={{
            pathname: '/CreatGroup_Aicp',
            state: {
              Ck_NameF: this.state.mongo.Ck_NameF,
              Ck_NameL: this.state.mongo.Ck_NameL,
              Ck_Brance: this.state.mongo.Ck_Brance,
              idfb: this.state.mongo.idfb,
              groupId: this.state.profile.groupId,
              password: this.state.pass
            }
          }}
        />
        }
      }
    // } else {
    //   //   alert(this.state.profile.groupId)
    //   //   alert(this.state.redi.redirectnogroup)
    //   if (this.state.redi.redirectnogroup != false) {
    //     return <Redirect
    //       to={{
    //         pathname: '/CircularIndeterminate',
    //         state: { id: this.state.profile.displayName }
    //       }}
    //     />
    //   }
    // }
  }

  render() {
    const classes = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer"
            >
              <MenuIcon />
            </IconButton>
            <Grid container justify="space-between" alignItems="center">
              {this.state.mongo.Ck_NameF}   {this.state.mongo.Ck_NameL}
              <div>
                <Avatar alt="Remy Sharp" src={this.state.profile.pictureUrl} className={classes.avatar} />
                {this.renderRedirect()}
              </div>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/ProfileNative.js